export default "__VITE_ASSET__XZOGWGB1__"